@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.modal-navigation-button {
  height: 40px;
  width: 40px;
  min-width: 40px;
  border-radius: 50%;
  background: @modal-navigation-button--background-color;
  font-size: 36px;
  line-height: 40px;
  cursor: pointer;

  > svg {
    height: 100%;
    width: 100%;
    fill: @modal-navigation-button--fill-color;
    transform: scale(0.4);
  }

  &:hover {
    background: @modal-navigation-button--hover--background-color;
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;

    &:hover {
      background: @modal-navigation-button--disabled--background-color;
    }
  }
}

@media (max-width: 1240px) {
  .modal-navigation-button {
    height: 30px;
    width: 30px;
    min-width: 30px;
    line-height: 30px;
  }
}
